export enum EFeatureFlags {
  MODULAR_PROCESS = 'modular-process',
  THEME = 'theme',
  USER_DETAIL = 'user-detail',
  WORK_PLAN_DETAIL_MANAGE_MODE = 'work-plan-detail-manage-mode',
  WORK_PLANS = 'work-plans',
  INBOX = 'inbox',
  RELEASE_NOTES = 'release-notes',
  PROCESS_REVIEW = 'process-review',
  // Legacy "common drill update" banner on the stack detail page. OFF by default
  // (the feature may be reworked). Enable via Unleash to bring the banner back.
  COMMON_DRILL_UPDATE = 'common-drill-update'
}
